import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, List, Row, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import Cards from 'react-credit-cards';
import { Title } from '../../components';
import Pagos360Form from '../../components/Pagos360Form';
import { instanceRef } from '../../utils/axios';

const getTipo = (tipo) => {
  switch (tipo) {
    case 'VI':
      return 'visa';
    case 'VD':
      return 'visa';
    case 'MC':
      return 'mastercard';
    case 'AE':
      return 'amex';
    case 'MD':
      return 'mastercard';

    default:
      return tipo;
  }
};

const PagosCartaVerdeForm = ({
  card,
  setCard,
  solicitud,
  loading,
  solicitando,
  idClienteLastCard,
  setErrorCatastro
}) => {
  const confirmado = false;

  const [tarjetas, setTarjetas] = useState([]);
  const [tarjetasVisible, setTarjetasVisible] = useState();
  const [eliminandoTarjeta, setEliminandoTarjeta] = useState(false);
  const [catastro, setCatastro] = useState();

  const eliminarTarjeta = async (idCliente, idTarjeta) => {
    try {
      setEliminandoTarjeta(true);
      await instanceRef.instance.delete(
        `pagos/cliente/${idCliente}/tarjetas/${idTarjeta}`
      );
      message.info('Tarjeta eliminada correctamente');
      setLastCard(idCliente);
    } catch (error) {
      message.error('No se pudo eliminar la tarjeta');
    }
    setEliminandoTarjeta(false);
  };

  const getClienteTarjetas = (id) => {
    return instanceRef.instance.get(`pagos/cliente/${id}/tarjetas`);
  };

  const setLastCard = useCallback(
    async (idCliente) => {
      const tarjetasResponse = await getClienteTarjetas(idCliente);
      setTarjetas(tarjetasResponse.data.data);
      if (
        !tarjetasResponse.data.data ||
        tarjetasResponse.data.data.length === 0
      ) {
        setCatastro(true);
        setTarjetasVisible(false);
      } else {
        const cardInfo = JSON.parse(
          tarjetasResponse.data.data[tarjetasResponse.data.data.length - 1]
            .card_info
        );
        setCard({
          id:
            tarjetasResponse.data.data[tarjetasResponse.data.data.length - 1]
              .id,
          cvc: '',
          expiry: `${cardInfo.expiration_month}/${cardInfo.expiration_year}`,
          name: cardInfo.holder_name,
          number: cardInfo.last4,
          issuer: getTipo(cardInfo.brand)
        });
      }
    },
    [setCard, setCatastro]
  );

  useEffect(() => {
    if (idClienteLastCard) {
      setLastCard(idClienteLastCard);
    }
  }, [idClienteLastCard, setLastCard]);

  return (
    <>
      {['tarjeta', 'cadebito', 'ccdebito'].includes(
        solicitud?.metodoPago?.codigo
      ) && (
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            margin: 'auto',
            textAlign: 'center'
          }}
          justify="center"
        >
          <Col xs={24} md={24} style={{ textAlign: 'center' }}>
            <Title>
              {confirmado && '¡Solicitud confirmada!'}
              {!confirmado &&
                `Confirme sus datos de ${solicitud?.metodoPago?.descripcion}`}
            </Title>
          </Col>
          <Col xs={24} md={12} style={{ textAlign: 'center' }}>
            {['cadebito', 'ccdebito'].includes(
              solicitud?.metodoPago?.codigo
            ) && (
              <Form.Item
                label="Número de cuenta"
                name="numeroCuenta"
                rules={[
                  {
                    required: true,
                    message: 'Campo requerido'
                  }
                ]}
              >
                <Input disabled={loading || solicitando} />
              </Form.Item>
            )}
            {solicitud?.metodoPago?.codigo === 'tarjeta' &&
              card &&
              !tarjetasVisible &&
              !catastro && (
                <>
                  <br />
                  <Cards
                    cvc={card.cvc}
                    expiry={card.expiry}
                    name={card.name}
                    number={card.number}
                    issuer={card.issuer}
                    preview
                    locale={{ valid: 'Válido hasta' }}
                    placeholders={{ name: '' }}
                  />
                  <br />
                  <Button
                    type="link"
                    onClick={() => {
                      setTarjetasVisible(true);
                      setCard();
                    }}
                  >
                    Usar otra
                  </Button>
                </>
              )}
            {solicitud?.metodoPago?.codigo === 'tarjeta' && catastro && (
              <>
                <Title>Catastro de tarjeta</Title>
                <div align="middle">
                  <div style={{ maxWidth: 500 }}>
                    <Pagos360Form
                      config={{
                        clientId: solicitud.cotizacion.persona.id_cliente
                      }}
                      type="bancard"
                      onSuccess={() => {
                        message.success('Tarjeta catastrada correctamente');
                        setCatastro(false);
                        setLastCard(solicitud.cotizacion.persona.id_cliente);
                        setErrorCatastro(false);
                      }}
                      onError={(data) => {
                        if (
                          data.error &&
                          data.error.message &&
                          data.error.message.code === 5001
                        ) {
                          message.error(
                            `Error al catastrar tarjeta: Verificar documento`
                          );
                        } else {
                          message.error(
                            `Error al catastrar tarjeta: ${JSON.stringify(
                              data
                            )}`
                          );
                        }
                        setErrorCatastro(true);
                      }}
                    />
                  </div>
                </div>
                <br />
                {tarjetas.length > 0 && (
                  <Button
                    onClick={() => {
                      setCatastro(false);
                      setTarjetasVisible(true);
                    }}
                  >
                    Usar existente
                  </Button>
                )}
              </>
            )}
          </Col>
        </Row>
      )}
      {tarjetasVisible && (
        <div align="middle">
          <Card
            title="Seleccione su tarjeta"
            style={{
              textAlign: 'left',
              maxWidth: 600,
              boxShadow: 'none'
            }}
            bordered={false}
            actions={[
              <Button
                onClick={() => {
                  setCatastro(true);
                  setTarjetasVisible(false);
                }}
              >
                Agregar Nueva
              </Button>
            ]}
            onCancel={() => setTarjetasVisible(false)}
          >
            <List
              size="small"
              itemLayout="vertical"
              dataSource={tarjetas.map((item) => {
                const cardInfo = JSON.parse(item.card_info);
                const innerCard = {
                  id: item.id,
                  cvc: '123',
                  expiry: `${cardInfo.expiration_month}/${cardInfo.expiration_year}`,
                  name: cardInfo.holder_name,
                  number: cardInfo.last4,
                  issuer: getTipo(cardInfo.brand),
                  last4: cardInfo.last4
                };
                return innerCard;
              })}
              renderItem={(item) => (
                <Card
                  actions={[
                    <Button
                      type="link"
                      icon={<CheckOutlined />}
                      disabled={eliminandoTarjeta}
                      onClick={() => {
                        setCard(item);
                        setTarjetasVisible(false);
                        setCatastro(false);
                      }}
                    />,
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      loading={eliminandoTarjeta}
                      onClick={() =>
                        eliminarTarjeta(
                          solicitud.cotizacion.persona.id_cliente,
                          item.id
                        )
                      }
                    />
                  ]}
                  style={{ marginTop: 20 }}
                  size="small"
                >
                  <List.Item
                    extra={
                      <div className="small">
                        <Cards
                          cvc={item.cvc}
                          expiry={item.expiry}
                          name={item.name}
                          number={item.number}
                          issuer={item.issuer}
                          preview
                          locale={{ valid: 'Válido hasta' }}
                          placeholders={{ name: '' }}
                        />
                      </div>
                    }
                  >
                    <List.Item.Meta
                      title={
                        <span style={{ textTransform: 'uppercase' }}>
                          {`${item.issuer}`}
                        </span>
                      }
                      description={`${item.last4}`}
                    />
                  </List.Item>
                </Card>
              )}
            />
          </Card>
        </div>
      )}

      <br />
    </>
  );
};

export default PagosCartaVerdeForm;
